module.exports = __webpack_public_path__ + "static/media/dice-d6.a9d3683c.svg";